export var dateParam = 'date';
export var shiftStartParam = 'shiftStart';
export var refParam = 'ref';
export var siteIdParam = 'siteId';
export var findShiftsRefValue = 'cln_vw';
export var locationEligibilityRefValue = 'hm_le_qklink';
export var goldModalRefValue = 'hm_fs_qklink';
export var weekParamString = 'week';
